// react_frontend/src/Components/Router/ProtectedRoute.js
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { AxiosAuthInstance } from "../../AxiosInterceptors";

export default function ProtectedRoute({ children, allowedRoles }) {
  const [loading, setLoading] = useState(true);
  const [hasLicense, setHasLicense] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const checkLicense = async () => {
      try {
        const res = await AxiosAuthInstance.get("/check-license");
        setHasLicense(res.data.valid);
        setIsAuthenticated(true);
        setUserRole(Number(localStorage.getItem("who_am_i")));
      } catch (err) {
        console.error("License check failed:", err);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    const token = localStorage.getItem("token");
    if (!token) {
      setIsAuthenticated(false);
      setLoading(false);
      return;
    }

    checkLicense();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (!isAuthenticated) return <Navigate to="/" replace />;
  if (!hasLicense) return <Navigate to="/license-expired" replace />;

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/error-401" replace />;
  }

  return children;
}
